import { handleActions } from 'redux-actions';
import {
  loadAllResults,
  paginateClients,
  paginateFolders,
  paginateDocumentations,
  paginateNotifications,
  paginateContacts,
  searchClients,
  searchFolders,
  searchDocumentation,
  searchNotificationResults,
  searchResultContacts,
  loadDocument,
  setAllClientData,
  setShowStateFilter,
  loadDocumentResults,
  // new variables
  setClientsCount,
  setContactsCount,
  setFoldersCount,
  setDocumentsCount,
  setCommunicationsCount,
  setMassiveCommunicationsCount,
  setGeneralSearchText,
} from 'redux/actions/resultActions';

const defualtState = {
  allClientResults: [],
  clientResults: [],
  currentClientResults: [],
  allFolderResults: [],
  folderResults: [],
  currentFolderResults: [],
  allDocumentationResults: [],
  documentationResults: [],
  currentDocumentations: [],
  allNotificationResults: [],
  notificationResults: [],
  currentNotificationResults: [],
  allContactResults: [],
  contactResults: [],
  currentContactResults: [],
  isDocument: false,
  allClientData: [],
  showStateFilter: false,
  clientsCount: 0,
  contactsCount: 0,
  foldersCount: 0,
  documentsCount: 0,
  communicationsCount: 0,
  massiveCommunicationsCount: 0,
  generalSearchText: '',
};

export default handleActions(
  {
    [loadAllResults](state, action) {
      const { clients, notifications, contacts, folders } = action.payload;
      return {
        ...state,
        allClientResults: clients,
        allFolderResults: folders,
        allNotificationResults: notifications,
        allContactResults: contacts.filter((x) => x.mail),
        clientResults: clients,
        folderResults: folders,
        notificationResults: notifications,
        contactResults: contacts.filter((x) => x.mail),
      };
    },
    [loadDocumentResults](state, action) {
      return {
        ...state,
        allDocumentationResults: action.payload,
        documentationResults: action.payload,
      };
    },
    [paginateClients](state, action) {
      const { page, pageSize } = action.payload;
      const start = (page - 1) * pageSize;
      const end = page * pageSize;
      const currentClientResults = [...state.clientResults].slice(start, end);
      return { ...state, currentClientResults };
    },
    [paginateFolders](state, action) {
      const { page, pageSize } = action.payload;
      const start = (page - 1) * pageSize;
      const end = page * pageSize;
      const currentFolderResults = [...state.folderResults].slice(start, end);
      return { ...state, currentFolderResults };
    },
    [paginateDocumentations](state, action) {
      const { page, pageSize } = action.payload;
      const start = (page - 1) * pageSize;
      const end = page * pageSize;
      const currentDocumentations = [...state.documentationResults].slice(start, end);
      return { ...state, currentDocumentations };
    },
    [paginateNotifications](state, action) {
      const { page, pageSize } = action.payload;
      const start = (page - 1) * pageSize;
      const end = page * pageSize;
      const currentNotificationResults = [...state.notificationResults].slice(start, end);
      return { ...state, currentNotificationResults };
    },
    [paginateContacts](state, action) {
      const { page, pageSize } = action.payload;
      const start = (page - 1) * pageSize;
      const end = page * pageSize;
      const currentContactResults = [...state.contactResults].slice(start, end);
      return { ...state, currentContactResults: currentContactResults.filter((x) => x.mail) };
    },
    [searchClients](state, action) {
      const { searchText, field } = action.payload;
      const lowerSearchText = searchText?.toLowerCase() ?? '';
      let clientResults = [...state.allClientResults];
      if (lowerSearchText.length > 0 && field === '0') {
        clientResults = state.allClientResults.filter((client) => {
          return (
            (client.clientName ?? '').toLowerCase().includes(lowerSearchText) ||
            (client.cif ?? '').toLowerCase().includes(lowerSearchText) ||
            (client.contactMail ?? '').toLowerCase().includes(lowerSearchText) ||
            (client.contactPhone ?? '').toLowerCase().includes(lowerSearchText) ||
            (client.direction ?? '').toLowerCase().includes(lowerSearchText) ||
            (client.state ?? '').toLowerCase().includes(lowerSearchText)
          );
        });
      }
      if (lowerSearchText.length > 0 && field !== '0') {
        clientResults = state.allClientResults.filter((client) =>
          (client[field] ?? '').toLowerCase().includes(lowerSearchText)
        );
      }
      if (!lowerSearchText.length) {
        clientResults = [...state.allClientResults];
      }
      return { ...state, clientResults };
    },
    [searchFolders](state, action) {
      const { searchText, field } = action.payload;
      const lowerSearchText = searchText?.toLowerCase() ?? '';

      let folderResults = [...state.allFolderResults];
      if (lowerSearchText.length > 0 && field === '0') {
        folderResults = state.allFolderResults.filter((folder) => {
          return (
            (folder.name ?? '').toLowerCase().includes(lowerSearchText) ||
            (folder.clientName ?? '').toLowerCase().includes(lowerSearchText)
          );
        });
      }
      if (lowerSearchText.length > 0 && field !== '0') {
        folderResults = state.allFolderResults.filter((folder) =>
          (folder[field] ?? '').toLowerCase().includes(lowerSearchText)
        );
      }
      if (!lowerSearchText.length) {
        folderResults = [...state.allFolderResults];
      }
      return { ...state, folderResults };
    },
    [searchDocumentation](state, action) {
      const { searchText, field } = action.payload;
      const lowerSearchText = searchText?.toLowerCase() ?? '';

      let documentationResults = [...state.allDocumentationResults];
      if (lowerSearchText.length > 0 && field === '0') {
        documentationResults = state.allDocumentationResults.filter((documentation) =>
          (documentation.name ?? '').toLowerCase().includes(lowerSearchText)
        );
      }
      if (lowerSearchText.length > 0 && field !== '0') {
        documentationResults = state.allDocumentationResults.filter((documentation) =>
          (documentation[field] ?? '').toLowerCase().includes(lowerSearchText)
        );
      }
      if (!lowerSearchText.length) {
        documentationResults = [...state.allDocumentationResults];
      }

      return { ...state, documentationResults };
    },
    [searchNotificationResults](state, action) {
      const { searchText, field } = action.payload;
      const lowerSearchText = searchText?.toLowerCase() ?? '';
      let notificationResults = [...state.allNotificationResults];
      if (lowerSearchText.length > 0 && field === '0') {
        notificationResults = state.allNotificationResults.filter((notification) => {
          return (notification.name ?? '').toLowerCase().includes(lowerSearchText);
        });
      }
      if (lowerSearchText.length > 0 && field !== '0') {
        notificationResults = state.allNotificationResults.filter((notification) =>
          (notification[field] ?? '').toLowerCase().includes(lowerSearchText)
        );
      }
      if (!lowerSearchText.length) {
        notificationResults = [...state.allNotificationResults];
      }
      return { ...state, notificationResults };
    },
    [searchResultContacts](state, action) {
      const { searchText, field } = action.payload;
      const lowerSearchText = searchText?.toLowerCase() ?? '';
      let contactResults = [...state.allContactResults];
      if (lowerSearchText.length > 0 && field === '0') {
        contactResults = state.allContactResults.filter((client) => {
          return (
            (client.name ?? '').toLowerCase().includes(lowerSearchText) ||
            (client.surname ?? '').toLowerCase().includes(lowerSearchText) ||
            (client.phone ?? '').toLowerCase().includes(lowerSearchText) ||
            (client.description ?? '').toLowerCase().includes(lowerSearchText) ||
            (client.mail ?? '').toLowerCase().includes(lowerSearchText)
          );
        });
      }
      if (lowerSearchText.length > 0 && field !== '0') {
        contactResults = state.allContactResults.filter((client) =>
          (client[field] ?? '').toLowerCase().includes(lowerSearchText)
        );
      }
      if (!lowerSearchText.length) {
        contactResults = [...state.allContactResults];
      }
      return { ...state, contactResults: contactResults.filter((x) => x.mail) };
    },
    [loadDocument](state, action) {
      return { ...state, isDocument: action.payload };
    },
    [setAllClientData](state, action) {
      return { ...state, allClientData: action.payload };
    },
    [setShowStateFilter](state, action) {
      return { ...state, showStateFilter: action.payload };
    },
    [setClientsCount](state, action) {
      return { ...state, clientsCount: action.payload };
    },
    [setContactsCount](state, action) {
      return { ...state, contactsCount: action.payload };
    },
    [setFoldersCount](state, action) {
      return { ...state, foldersCount: action.payload };
    },
    [setDocumentsCount](state, action) {
      return { ...state, documentsCount: action.payload };
    },
    [setCommunicationsCount](state, action) {
      return { ...state, communicationsCount: action.payload };
    },
    [setMassiveCommunicationsCount](state, action) {
      return { ...state, massiveCommunicationsCount: action.payload };
    },
    [setGeneralSearchText](state, action) {
      return { ...state, generalSearchText: action.payload };
    },
  },
  defualtState
);
